"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.ECOVALUS;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "numberOptional",
  extraText: "In the past month, how many times did you use any of the following services?",
  eval: function _eval(n) {
    return n;
  }
};
var ecoValQuestions = [{
  prompt: "GP (General Practitioner)"
}, {
  prompt: "Psychologist, clinical psychologist, counsellor or psychotherapist"
}, {
  prompt: "Psychiatrist"
}, {
  prompt: "Specialist doctor (e.g., cardiologist, neurologist, oncologist etc.)"
}, {
  prompt: "Social worker, Nurse or Mental Health Nurse"
}, {
  prompt: "Other therapist (e.g. physiotherapist, dietician, osteotherapist, chiropractor etc.)"
}, {
  prompt: "Alternative Medicine (e.g. acupuncturist, homeopath)"
}, {
  prompt: "Ambulance service or paramedic"
}, {
  prompt: "Support group"
}, {
  prompt: "Private hospital as an inpatient (overnight stay)"
}, {
  prompt: "Private hospital as an outpatient (day visit/no overnight stay)"
}, {
  prompt: "Public hospital as an inpatient (overnight stay)"
}, {
  prompt: "Public hospital as an outpatient (day visit/no overnight stay)"
}, {
  prompt: "Other clinic (e.g., clinic for drug or alcohol treatment)"
}, {
  prompt: "Charity service (e.g., Salvation Army)"
}, {
  prompt: "Paid Home Care"
}, {
  prompt: "Unpaid Home Care (person took half day or more off work to care)"
}, {
  prompt: "Prescribed Medication/Medicine"
}, {
  prompt: "Non-prescribed medication/medicine (e.g. paracetemol etc)."
} // {
// 	prompt: "For how many days/hours does your WorkCover Certificate of Capacity/Fitness for Work Certificate (completed by your GP) say that you have capaicty for work?",
// 	key: "capacityToWork",
// 	type: "radioWithInputs",
// 	options: [
// 		{label: "No current capacity for any work"},
// 		{
// 			label: "What is your current capacity for work, as determined by your physician?",
// 			inputs: ["days a week", "hours a day"]
// 		},
// 		{label: "Is fit for pre-injury work"},
// 		{label: "I don’t know"}
// 	],
// 	subPrompt: " ",
// 	batteryId: batteryId
// },
// {
// 	prompt: "Are you currently back at work? ",
// 	key: "backAtWork",
// 	type: "radioWithInputs",
// 	options: [{label: "Yes"}, {label: "No"}],
// 	batteryId: batteryId
// }
];
var questions = (0, _utils.wrapBattery)(ecoValQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers));
  return {
    ECOVAL: score,
    ECOVAL_1: answers[0],
    ECOVAL_2: answers[1],
    ECOVAL_3: answers[2],
    ECOVAL_4: answers[3],
    ECOVAL_5: answers[4],
    ECOVAL_6: answers[5],
    ECOVAL_7: answers[6],
    ECOVAL_8: answers[7],
    ECOVAL_9: answers[8],
    ECOVAL_10: answers[9],
    ECOVAL_11: answers[10],
    ECOVAL_12: answers[11],
    ECOVAL_13: answers[12],
    ECOVAL_14: answers[13],
    ECOVAL_15: answers[14],
    ECOVAL_16: answers[15],
    ECOVAL_17: answers[16],
    ECOVAL_18: answers[17],
    ECOVAL_19: answers[18],
    ECOVAL_20: answers[19],
    ECOVAL_21: answers[20]
  };
}